import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=9a6c57e2&scoped=true&"
import script from "./OtpInput.vue?vue&type=script&lang=js&"
export * from "./OtpInput.vue?vue&type=script&lang=js&"
import style0 from "./OtpInput.vue?vue&type=style&index=0&id=9a6c57e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c57e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a6c57e2')) {
      api.createRecord('9a6c57e2', component.options)
    } else {
      api.reload('9a6c57e2', component.options)
    }
    module.hot.accept("./OtpInput.vue?vue&type=template&id=9a6c57e2&scoped=true&", function () {
      api.rerender('9a6c57e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OtpInput.vue"
export default component.exports